import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import FiltrosPedidosVenta from '../../components/pedidosVenta/FiltrosPedidosVenta'
import { abrirModalPedidosVenta, abrirModalPrevisionPedidos, seleccionarTodosPedidosVenta, deseleccionarTodosPedidosVenta, deleteSeleccionPedidosVenta, confirmarSeleccionPedidosVenta, fetchFiltrarPedidosVenta, exportarPedidosVenta,
  imprimirPedidosVenta, descargarPedidosCloud, abrirModalImportarPedidosCuartesa} from '../../actions/pedidosVenta/pedidosVenta'
import {comboNumeroPedido, comboCliente, comboTipoDosis, comboRuta} from '../../actions/combos/combos'

export function mapStateToProps (state) {
  return {
    ...state.pedidosVenta,
    numeroRegistrosPorPagina: state.common.numeroRegistrosPorPagina,
    paginaActual: state.common.paginaActual,
    formSimpleTable: state.form.simpleTable,
    auth: state.auth,
    combos: state.combos
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      abrirModalPedidosVenta,
      abrirModalPrevisionPedidos,
      seleccionarTodosPedidosVenta,
      deseleccionarTodosPedidosVenta,
      deleteSeleccionPedidosVenta,
      confirmarSeleccionPedidosVenta,
      comboNumeroPedido,
      comboCliente,
      comboTipoDosis,
      comboRuta,
      fetchFiltrarPedidosVenta,
      exportarPedidosVenta,
      imprimirPedidosVenta,
      descargarPedidosCloud,
      abrirModalImportarPedidosCuartesa
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(FiltrosPedidosVenta))